import JSONBigInt from 'json-bigint';

export const requestBodyFormatter = (json: unknown): string =>
  `request=${encodeURIComponent(
    JSONBigInt.stringify({
      request: json,
    }),
  )}`;
